import { render, staticRenderFns } from "./NormalSkeleton.vue?vue&type=template&id=02bdc84e"
import script from "./NormalSkeleton.vue?vue&type=script&lang=js"
export * from "./NormalSkeleton.vue?vue&type=script&lang=js"
import style0 from "./NormalSkeleton.vue?vue&type=style&index=0&id=02bdc84e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports